import config from "../config.json";
import taxes from "../taxes.json";

export const get_financial_rent = (values) => {
    let r = values.interest_rate / 100 / 12;
    let n = values.duration;
    let pv = values.net_discounted_price;
    let fv = -values.residual_value;

    return -Math.round((r / (Math.pow(1 + r, n) - 1)) * -(pv * Math.pow(1 + r, n) + fv));
};

export const get_vehicle_tco = (values) => {
    let vehicle_tco = 0;
    if (values.has_maintenance) {
        vehicle_tco += values.maintenance;
    }
    if (values.has_assistance) {
        vehicle_tco += values.assistance;
    }
    if (values.has_tires) {
        vehicle_tco += values.tires;
    }
    if (values.has_insurance) {
        vehicle_tco += values.insurance;
    }
    return Math.round(vehicle_tco);
};

export const get_taxes = (values) => {
    let taxes_amount = 0;
    if (values.has_taxes) {
        taxes_amount += // Taxe d'immatriculation
            ((values.cv * 23 +
                // Timbres fiscaux
                6.76) *
                // Exonération
                taxes.taxes_vs_nrj[values.vehicle_fuel]["CG"] +
                // Bonus / Malus
                taxes.taxes_vs_co2[values.co2_emissions]["B/M"]) /
                values.duration +
            // TVS et Taxe Air
            (taxes.taxes_vs_co2[values.co2_emissions]["TVS"] *
                Math.max((values.duration - taxes.taxes_vs_nrj[values.vehicle_fuel]["TVS (mois)"]) / 12, 0)) /
                values.duration +
            taxes.taxes_vs_nrj[values.vehicle_fuel]["Taxe Air"] / 12;

        if (values["net_discounted_price"] - taxes.taxes_vs_co2[values.co2_emissions]["AND"] > 0) {
            taxes_amount +=
                ((values["net_discounted_price"] - taxes.taxes_vs_co2[values.co2_emissions]["AND"]) *
                    taxes.is) /
                100 /
                4 /
                12;
        }
    }

    return Math.round(taxes_amount);
};

export const get_company_tco = (values) => {
    let company_tco = 0;
    if (values.has_taxes) {
        company_tco += // Taxe d'immatriculation
            ((values.cv * 23 +
                // Timbres fiscaux
                6.76) *
                // Exonération
                taxes.taxes_vs_nrj[values.vehicle_fuel]["CG"] +
                // Bonus / Malus
                taxes.taxes_vs_co2[values.co2_emissions]["B/M"]) /
                values.duration +
            // TVS et Taxe Air
            (taxes.taxes_vs_co2[values.co2_emissions]["TVS"] *
                Math.max((values.duration - taxes.taxes_vs_nrj[values.vehicle_fuel]["TVS (mois)"]) / 12, 0)) /
                values.duration +
            taxes.taxes_vs_nrj[values.vehicle_fuel]["Taxe Air"] / 12;

        if (values["net_discounted_price"] - taxes.taxes_vs_co2[values.co2_emissions]["AND"] > 0) {
            company_tco +=
                ((values["net_discounted_price"] - taxes.taxes_vs_co2[values.co2_emissions]["AND"]) *
                    taxes.is) /
                100 /
                4 /
                12;
        }
    }

    if (values.has_fuel) {
        company_tco +=
            ((((values.co2_emissions / 1000) *
                values.duration *
                values.mileage *
                (1 / config.emissions_conversion[values.vehicle_fuel])) /
                12) *
                config.fuel_price[values.vehicle_fuel]) /
            values.duration;
    }
    return Math.round(company_tco);
};



// WEBPACK FOOTER //
// ./src/helpers/tco-calculator.js